module.exports = __webpack_public_path__ + "sq12-d2b22a6a.png";